import { useEffect } from 'react';
import { useGamificationSettings } from './useGamificationSettings';

/**
 * Hook to manage reduced motion mode across the application.
 * When enabled, adds a CSS class to the document root that disables animations.
 * Also respects the user's system preference for reduced motion.
 */
export const useReduceMotion = () => {
  const { settings } = useGamificationSettings();
  
  useEffect(() => {
    // Check system preference as a fallback
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (settings.reduceMotion || prefersReducedMotion) {
      document.documentElement.classList.add('reduce-motion');
    } else {
      document.documentElement.classList.remove('reduce-motion');
    }
  }, [settings.reduceMotion]);
  
  return settings.reduceMotion;
};
